module.exports = __webpack_public_path__ + "img/periodic_overstay_off.756d9890.png";